import { useCanReschedule } from './use-can-reschedule'

export function useRescheduleAllowed(code: string): boolean {
  const { data, isError } = useCanReschedule(code)
  return !isError && data?.canReschedule === true
}
